export class RequestBuildingUnitView {
  id: number;
  buildingId: number;
  buildingName: string;
  buildingLevelId: number;
  levelName: string;
  unitId: number;
  name: string;
  buildingUnitTypeId: number;
  unitTypeName: string;
  isPrimary: boolean;
  isSelected: boolean;
  isDeleted: boolean;
}



// WEBPACK FOOTER //
// ./src/app/core/models/event-request-building-unit-view.ts